export default {
    methods: {
        async getDadosOCR(tipo) {
            const storedData = await localStorage.getItem('apiResponse');

            if (storedData !== null) {
                const parsedData = JSON.parse(storedData);

                if (parsedData.data && Array.isArray(parsedData.data) && parsedData.data.length > 0) {

                    const personData = parsedData.data[0]?.extraction?.person || {};
                    const pais_doc = parsedData.data[0]?.enhanced?.person || {};
                    const doc = parsedData.data[0]?.enhanced?.otherFields || {};

                    const unique = {...personData, ...pais_doc, ...doc};


                    if (!this.id_user && tipo === 'PJ') {
                        this.dados = {
                            nm: unique.name || '',
                            nm_cpfcontato: unique.taxId || '',
                            dt_nascimento: unique.birthdate || '',
                            nm_mae: unique.mothersName || '',
                            nm_pai: unique.fathersName || '',
                            nm_rgouie: (unique.sourceDocument || unique.documentId) || '',
                            nm_orgaoemissor: unique.sourceDocumentIssuer || '',
                        };
                    }
                     else if (!this.id_user && tipo === 'PF') {
                        this.dados = {
                            nm: unique.name || '',
                            nm_cpfoucnpj: unique.taxId || '',
                            dt_nascimento: unique.birthdate || '',
                            nm_mae: unique.mothersName || '',
                            nm_pai: unique.fathersName || '',
                            nm_rgouie: (unique.sourceDocument || unique.documentId) || '',
                            nm_orgaoemissor: unique.sourceDocumentIssuer || '',
                        };
                    }
                }
            }
        }
    }
}